import api from "./API";

/**
 * Item Issue Return Service
 * API service for managing item returns from departments (formerly returns)
 */

export const itemIssueReturnService = {
  /**
   * Get all item issue returns with optional filters and pagination
   * @param {Object} params - Query parameters (page, limit, department, status, etc.)
   * @returns {Promise} API response with item issue returns list
   */
  getItemIssueReturns: (params) => api.get("/item-issue-returns", { params }),

  /**
   * Get a single item issue return by ID
   * @param {string} id - Item issue return ID
   * @returns {Promise} API response with item issue return details
   */
  getItemIssueReturn: (id) => api.get(`/item-issue-returns/${id}`),

  /**
   * Create a new item issue return
   * @param {Object} data - Item issue return data
   * @returns {Promise} API response with created item issue return
   */
  createItemIssueReturn: (data) => api.post("/item-issue-returns", data),

  /**
   * Approve an item issue return
   * @param {string} id - Item issue return ID
   * @param {Object} data - Approval data (approvedBy, notes, etc.)
   * @returns {Promise} API response with approved item issue return
   */
  approveItemIssueReturn: (id, data = {}) => 
    api.put(`/item-issue-returns/${id}/approve`, data),

  /**
   * Reject an item issue return
   * @param {string} id - Item issue return ID
   * @param {Object} data - Rejection data (rejectedBy, rejectionReason, etc.)
   * @returns {Promise} API response with rejected item issue return
   */
  rejectItemIssueReturn: (id, data) => 
    api.put(`/item-issue-returns/${id}/reject`, data),

  /**
   * Complete an item issue return (restock or dispose)
   * @param {string} id - Item issue return ID
   * @param {Object} data - Completion data
   * @returns {Promise} API response with completed item issue return
   */
  completeItemIssueReturn: (id, data = {}) => 
    api.put(`/item-issue-returns/${id}/complete`, data),

  /**
   * Get returns by item issue ID
   * @param {string} itemIssueId - Item issue ID
   * @returns {Promise} API response with returns for the item issue
   */
  getByItemIssue: (itemIssueId) => 
    api.get(`/item-issue-returns/item-issue/${itemIssueId}`),

  /**
   * Check return eligibility for an item issue
   * @param {string} itemIssueId - Item issue ID
   * @returns {Promise} API response with eligibility status
   */
  checkEligibility: (itemIssueId) => 
    api.get(`/item-issue-returns/check-eligibility/${itemIssueId}`),
};

export default itemIssueReturnService;
